import React from 'react'
import Button from '@mui/material/Button'
import { useTranslation } from 'react-i18next'
import './BrandedButton.style.scss'

export const BrandedButton = ({
  onClick,
  buttonLabel,
  disabled = false,
  startIcon,
  danger = false,
  success = false,
  secondary = false,
  loading = false,
  iconOnly = false
}) => {
  const { t } = useTranslation()
  return (
    <div className={`brandedButton${danger ? ' brandedButton--danger' : ''}${success ? ' brandedButton--success' : ''}${secondary ? ' brandedButton--secondary' : ''}`}>
      <Button
        className="buttonColor"
        color="primary"
        onClick={onClick}
        disabled={disabled || loading}
        startIcon={iconOnly ? undefined : startIcon}
        sx={iconOnly ? { minWidth: 'auto', padding: '8px', '& svg': { width: 20, height: 20 } } : {}}
      >
        {iconOnly ? startIcon : loading ? t('Saving...') : t(buttonLabel)}
      </Button>
    </div>
  )
}
